// Source-system helpers for the Visits Viewer (frontend).
// Backend twin: backend/utils/visitsSource.js.
//
// The module reads one warehouse table holding several source systems, and a
// campaign id is only unique WITHIN a source. A project is therefore the PAIR
// (source, projectId), and every project-scoped request has to carry both.

// Links shared before the multi-source rollout carry only ?projectId=, and every
// project was TeamHaven back then — so an absent source means TH, not "all".
export const DEFAULT_SOURCE = 'TH';

/** The source of a selected project, falling back to the historical default. */
export const sourceOf = (project) => project?.sourceSystem || DEFAULT_SOURCE;

/** Ready-to-append query fragment, e.g. `source=TH`. */
export const sourceParam = (project) => `source=${encodeURIComponent(sourceOf(project))}`;
